import { useEffect } from 'react';

import { FieldControllerProps } from '@dreryk/react-common';
import { Checkbox, ClassNameProp } from '@dreryk/react-components';

import { usePrintWithExplanationsAndNoticePreference } from '../../entitlementStatements/create/hooks/usePrintWithExplanationsAndNoticePreference.hook';
import { EntitlementStatementCreateModalProps } from '../../entitlementStatements/create/modal/EntitlementStatementCreateModal';
import { entitlementStatementsTranslationKeys } from '../../translations';

type PrintWithExplanationsAndNoticeCheckboxProps = FieldControllerProps<'printWithExplanationsAndNotice', boolean> &
   ClassNameProp;

export const PrintWithExplanationsAndNoticeCheckbox = (
   props: EntitlementStatementCreateModalProps & PrintWithExplanationsAndNoticeCheckboxProps
): JSX.Element => {
   const {
      printWithExplanationsAndNoticePreference,
      handleSetPrintWithExplanationsAndNoticePreference,
   } = usePrintWithExplanationsAndNoticePreference();

   const handleClick = (value: boolean): void => {
      handleSetPrintWithExplanationsAndNoticePreference(value);
      props.setPrintWithExplanationsAndNotice(value);
   };

   useEffect(() => {
      props.setPrintWithExplanationsAndNotice(printWithExplanationsAndNoticePreference);
   }, [printWithExplanationsAndNoticePreference, props]);

   return (
      <Checkbox
         testId={props.name}
         label={entitlementStatementsTranslationKeys.createModal.printWithExplanationsAndNotice}
         controller={props.register(props.name, {
            required: props.required,
         })}
         defaultValue={printWithExplanationsAndNoticePreference}
         onSelectionChange={handleClick}
      />
   );
};
